document.addEventListener('DOMContentLoaded', function () {
setTimeout(function(){
  // Step 1: Select the target element
const targetElement = document.querySelector('.new-review-form .spr-form-title');

// Step 2: Create a new element
const newElement = document.createElement('p');
newElement.textContent = 'We want people to know about our brilliant artisans, so we will use your quote on our website and in marketing'; // You can customize the content here

// Step 3: Insert the new element just after the target element
targetElement.insertAdjacentElement('afterend', newElement);

  }, 3000);
});